// On hold per user request — flip to true to show New Updates again.
export const UPDATES_ENABLED = false;

// Newest first. Add an entry here with every feature release — it appears in the Quick Start Guide → New Updates.
export const WHATS_NEW = [
  {
    id: '2026-10-16-invoice-ui', date: '2026-10-16', title: 'Cleaner New Invoice page',
    points: [
      'Customer and Applicant headings are bold and larger; the top three cards are the same height.',
      'Invoice list is sorted by invoice number inside each day — latest number on top.',
      'Drafts show an "Invoice #" column when they came from a saved invoice (Make Draft).',
    ],
  },
  {
    id: '2026-10-16-draft-number', date: '2026-10-16', title: 'Smarter draft invoice numbers',
    points: [
      'Making the latest invoice a draft frees its number; older invoices keep their number and reuse it on save.',
      'The invoice number appears only after you click Create Invoice.',
    ],
  },
  {
    id: '2026-10-16-unsaved', date: '2026-10-16', title: 'Unsaved bill warning & Advance Held',
    points: [
      'You are asked before leaving the New Invoice page if the bill has unsaved items.',
      'Customer card shows "Advance Held" in place of Due when the customer has advance.',
      'Invoice date is locked by default — tap the pencil to change it.',
    ],
  },
  {
    id: '2026-10-16-bill-history', date: '2026-10-16', title: 'Bill history on New Invoice',
    points: [
      'Pick a customer to see all previous bills and drafts, latest first.',
      'Tick or untick "Bill history" to show or hide it; tap the pencil to open any bill for editing.',
    ],
  },
  {
    id: '2026-10-16-payment', date: '2026-10-16', title: 'Expense is now "Payment"',
    points: [
      'Pay expenses, creditors (loan / card) or capital drawings from Cash or Bank in one place.',
      'The quick Payment button on the invoice page offers the same heads.',
    ],
  },
  {
    id: '2026-10-16-receipts', date: '2026-10-16', title: 'Receipt mode change & last 25 entries',
    points: [
      'Change a receipt from Cash to Bank (or back) — every change is logged with who and when.',
      'Receipt, Income, Payment, Transfer and Refund lists show the last 25 entries by default.',
    ],
  },
];
